export default __webpack_public_path__ + "static/GT-Super-Display-Bold-Italic-669ca8bfdb062d8ad4980b6f604e7b19.woff";